import { Position } from '../../types/tracking/model';

export function getTimeFromPosition(position: Position): Date {
    return new Date(position[0]);
}

export function getCoordsFromPosition(position: Position): [number, number] {
    return [position[1], position[2]];
}
